import dealExplorerScreen from '../../../assets/images/deal_explorer_screen.png';
import GuestModal from '../../../modals/Guest/Guest.modal';
import { Claim } from '../../../types';

export type GuestNavigationModalTarget = 'community' | 'coaching' | 'vendors';

const MODAL_TITLES: Record<GuestNavigationModalTarget, string> = {
	community: 'to Community?',
	coaching: 'to 1 on 1 with Tom?',
	vendors: 'to verified vendors?',
};

export const getGuestNavigationModalTarget = (
	claim: number,
): GuestNavigationModalTarget | null => {
	switch (claim) {
		case Claim.Messenger:
		case Claim.Community:
			return 'community';
		case Claim.Coaching:
			return 'coaching';
		case Claim.Vendors:
			return 'vendors';
		default:
			return null;
	}
};

interface GuestNavigationModalProps {
	target: GuestNavigationModalTarget | null;
	onClose: VoidFunction;
}

export const GuestNavigationModal = ({
	target,
	onClose,
}: GuestNavigationModalProps) => (
	<GuestModal
		isOpen={target !== null}
		onClose={onClose}
		title="Want access "
		underlineTitle={target ? MODAL_TITLES[target] : ''}
		highlightedSubtitle="Join our FREE webinar"
		secondSubtitle=" to gain access"
		buttonName="Go to webinar"
		imageScreen={dealExplorerScreen}
		move={true}
	/>
);
